module.exports = __webpack_public_path__ + "static/media/MU_Landing_Page_SC_4x5.5180b51c.vtt";